import React, { useState, useEffect } from "react";
import {
  Switch,
  FormControlLabel,
  Card,
  Grid,
  CardContent,
} from "@mui/material/";

/* Functional component properties */
interface Props {
  classes: any;
  showHeaders: boolean;
  handleSwitchChange: () => void;
}

/* React Functional component */
export const SwitchComponent: React.FC<Props> = ({
  /* Function arguments (Props) */
  classes,
  showHeaders,
  handleSwitchChange,
}): JSX.Element => {
  // console.log("SwitchComponent: ", showHeaders);
  const [label, setLabel] = useState("");

  useEffect(() => {
    if (showHeaders) setLabel("Hide Headers");
    else setLabel("Show Headers");
  });

  return (
    <Grid item xs={12} lg={12}>
      <Card>
        <CardContent>
          <FormControlLabel
            className={classes.switchButton}
            control={
              <Switch checked={showHeaders} onChange={handleSwitchChange} />
            }
            label={label}
          />
        </CardContent>
      </Card>
    </Grid>
  );
};
